import { Skeleton } from "@pushpress/pushpress-ui";
import { cn } from "../../../utils/css";
import {
  Sentiment,
  SentimentIcon,
} from "../DashboardSheetContent/SentimentIcon";
import UserActivityAvatars, { UserActivityInfo } from "./ActivityAvatarGroup";

interface ActivityItemProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  count: number;
  itemSentiment?: Sentiment;
  onClick?: () => void;
  isLoading?: boolean;
  userInformation?: UserActivityInfo[];
}

const ActivityItem: React.FC<ActivityItemProps> = ({
  icon,
  title,
  subtitle,
  count,
  itemSentiment,
  onClick,
  isLoading,
  userInformation,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className={cn(
        "tw-w-full tw-text-left tw-flex tw-items-center tw-justify-between tw-border-gray-200",
        "tw-bg-white tw-group tw-rounded-lg tw-border tw-py-2 tw-px-4",
        "tw-transition-all tw-duration-300 tw-ease-in-out",
        "hover:tw-bg-gray-50/50 hover:tw-cursor-pointer",
        "hover:tw-outline tw-outline-gray-100 hover:tw-border-gray-200",
        "tw-min-h-[100px]",
      )}
    >
      <div className="tw-flex tw-items-center tw-space-x-4">
        <SentimentIcon sentiment={itemSentiment} icon={icon} />
        <div className="tw-flex tw-flex-col">
          <p className="tw-font-medium tw-text-gray-500">
            {title}{" "}
            {subtitle && (
              <p className="tw-text-xs tw-text-gray-400">{subtitle}</p>
            )}
          </p>
          <p className="tw-text-lg tw-font-bold">
            {isLoading ? <Skeleton className="tw-h-7 tw-w-20" /> : count}
          </p>
        </div>
      </div>

      <UserActivityAvatars
        users={userInformation}
        maxVisibleIcons={3}
        isLoading={isLoading}
      />
    </button>
  );
};

export default ActivityItem;
